import Vue from 'vue'
import gql from 'graphql-tag'
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { ApolloResponse } from '@/interfaces/apollo'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTextField from '@/components/AppTextField.vue'
import carrierDialog from '@/modules/Carrier/scripts/carrier-dialog'
import { getCarriers, editCarrier } from '@/modules/Carrier/gql/carrier.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTextField
  }
})
export default class CarrierList extends mixins(carrierDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Carriers'
    }
  ]
  searchVal = ''

  carriers: Carrier[] = []

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    name: 'NAME'
  }

  renaming = false
  nullCarrierName = false
  renameCarrierName = ''

  tableColumn = [
    { field: 'name', title: 'Carrier Name', sortable: true, slots: { default: 'name_default' } },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 112 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  mounted () {
    this.getCarriers()
  }

  async getCarriers () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const searchVal = this.searchVal ? this.searchVal : null
    const orderBy = this.orderBy[sortBy] || 'ID'
    const asc = sortDesc || false
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCarriers,
        variables: {
          filter: {
            name: searchVal
          },
          order: {
            orderBy: orderBy,
            asc: !asc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.carriers = result.data.getCarriers.carriers
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getCarriers.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  renameCarrier (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCarrier = Object.assign({}, item)
    this.renameCarrierName = item.name
    this.renaming = true
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  async renameConfirm (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.nullCarrierName = !this.renameCarrierName
    if (this.nullCarrierName) {
      return
    }
    await this.renameCarrierNameConfirm()
    this.renaming = false
  }

  async renameCancel (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.renaming = false
    this.renameCarrierName = ''
  }

  async renameCarrierNameConfirm () {
    if (!this.targetCarrier) {
      return
    }
    const { id } = this.targetCarrier
    try {
      await this.$apollo.mutate({
        mutation: editCarrier,
        variables: {
          carrierId: Number(id),
          carrierInput: {
            name: this.renameCarrierName
          }
        }
      })
      showNotification({
        msg: 'Update the carrier name successfully',
        type: SnackType.Success
      })
      this.getCarriers()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  refreshList () {
    this.searchVal = ''
    this.getCarriers()
  }

  async deleteCarrierConfirm () {
    await this.deleteCarrierPost()
    this.getCarriers()
  }

  routeToDetail (item: any) {
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getCarriers()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getCarriers()
  }
}
